import Vue from "vue";
export default Vue.extend({
    name: 'UBLogo',
    props: {
        fillColor: {
            type: String,
            default: '#dedc03'
        },
        width: {
            default: 73.54
        },
        height: {
            default: 69.61
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/UBLogo/UBLogo.ts
// module id = null
// module chunks = 